import { Text, WrapperFlex } from '@unimed-fesp/components';
import React from 'react';
import theme from '../../../styles/theme';

export function InfoDisplayItem({ title, content }) {
  return (
    <WrapperFlex column>
      <Text
        font="bold 16px/14px Calibri"
        color={theme.movGrey}
        paddingBottom={5}
        text={title}
      />
      <Text color={theme.movGrey90} text={content || '-'} paddingBottom={5} />
    </WrapperFlex>
  );
}
